import { Utils } from '../../../../../../../core/utils/utils';
import { Injectable } from '@angular/core';
import { forkJoin, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import * as _ from 'lodash';
import { Dbmodels } from '../../../../../../../core/entities/dbmodels.model';
import { Xmldefs } from '../../../../../../../core/entities/xmldefs.model';
import { Dbattrs } from '../../../../../../../core/entities/dbattrs.model';
import { DbmodelsService } from '../../../../../../../core/repositories/dbmodels.service'
import { SelectItem } from 'primeng/api';
import { InternalHomeService } from '../../../../../internal-home/internal-home.service';

@Injectable()
export class EditDialogsDbmodelsService {

  dbmodels: Dbmodels = new Dbmodels();
  originalDbmodels: Dbmodels = new Dbmodels();
  parametersInput: Dbmodels = new Dbmodels();

  optionsXmls: SelectItem[] = [];
  optionsDbattrs: SelectItem[] = [];

  optionsXmlBase: SelectItem[] = [];
  optionsDbattrBase: SelectItem[] = [];

  allDbmodels: Dbmodels[] = [];
  changetitulo: boolean = false;

  xmls: Xmldefs[] = new Array<Xmldefs>();
  dbattrs: Dbattrs[] = new Array<Dbattrs>();

  constructor(private dbmodelsService: DbmodelsService,
              private internalHomeService: InternalHomeService) { }

  /**
  * Inicia el dialog
  * @param data Datos recibidos por el dialog
  */
  init(data: any): Observable<boolean> {
    this.dbmodels = data.dbmodel;
    this.changetitulo = data.titulochange;
    this.originalDbmodels = _.cloneDeep(this.dbmodels);
    console.log(data);

    return forkJoin([this.internalHomeService.allDbattrs(),
                    this.internalHomeService.allXmldefs()]).pipe(map(dataGroup => {
      console.log(dataGroup);

      this.dbattrs = dataGroup[0];
      this.xmls = dataGroup[1];

      this.optionsXmlBase.push({value: null, label: ""});
      this.optionsDbattrBase.push({value: null, label: ""})

      for(let i = 0; i < this.dbattrs.length; i++){
        this.optionsDbattrBase.push({value: this.dbattrs[i].code, label: this.dbattrs[i].code});
      }

      for(let i = 0; i < this.xmls.length; i++){
        this.optionsXmlBase.push({value: this.xmls[i].code, label: this.xmls[i].code});
      }

      this.optionsDbattrs = this.optionsDbattrBase;
      this.optionsXmls = this.optionsXmlBase;

      if (Utils.noUndfAndNull(data.dbmodel)) {
        this.dbmodels = _.cloneDeep(data.dbmodel);
      }

      this.optionsDbattrBase = [];
      this.optionsXmlBase = [];

      return true;
    }));
  }


  /**
  * @description
  * Guarda el dbmodel
  */
  public guardar(): Observable<any> {
    console.log('guardar');
    if (Utils.noUndfAndNull(this.dbmodels.id, "")) {

      /*comparamos el dbmodel original con el modificado*/
      let compareDbmodel = this.compare(this.dbmodels, this.originalDbmodels);

      if(compareDbmodel){
        return of(-1);
      }else{
        for(let i = 0; i < this.dbattrs.length; i++){
          if(this.dbmodels.dbattrId.code === this.dbattrs[i].code){
            this.dbmodels.dbattrId.id = this.dbattrs[i].id;
          }
        }
        for(let i = 0; i < this.xmls.length; i++){
          if(this.dbmodels.xmldefId.code === this.xmls[i].code){
            this.dbmodels.xmldefId.id = this.xmls[i].id;
          }
        }
        return this.dbmodelsService.postDbmodel(this.dbmodels);
      }

    }else{
      for(let i = 0; i < this.dbattrs.length; i++){
        if(this.dbmodels.dbattrId.code === this.dbattrs[i].code){
          this.dbmodels.dbattrId.id = this.dbattrs[i].id;
        }
      }
      for(let i = 0; i < this.xmls.length; i++){
        if(this.dbmodels.xmldefId.code === this.xmls[i].code){
          this.dbmodels.xmldefId.id = this.xmls[i].id;
        }
      }
      return this.dbmodelsService.postDbmodel(this.dbmodels);
    }
  }

  /**
  * @description
  * Comprueba si dos Dbmodels son iguales.
  * @param datoX Dbmodel 1
  * @param datoY Dbmodel 2
  * @returns True si son iguales
  */
  public compare(itemX:Dbmodels, itemY:Dbmodels):boolean {
    //Ambos objetos están definidos y no son nulos
    if (Utils.noUndfAndNull(itemX) && Utils.noUndfAndNull(itemY)) {

      if (itemX.dbattrId.code !== null) {
        let value = itemX.dbattrId.code.toString();
        if (value === 'null') {
          itemX.dbattrId.code = "";
        }
      }
      if (itemX.xmldefId.code !== null) {
        let value = itemX.xmldefId.code.toString();
        if (value === 'null') {
          itemX.xmldefId.code = "";
        }
      }

      if ((!Utils.compareTextOrNumber(itemX.code, itemY.code)
      || !Utils.compareTextOrNumber(itemX.description, itemY.description)
      || !Utils.compareTextOrNumber(itemX.dbattrId.code, itemY.dbattrId.code)
      || !Utils.compareTextOrNumber(itemX.xmldefId.code, itemY.xmldefId.code)
      || !Utils.compareTextOrNumber(itemX.dbobjname, itemY.dbobjname))
      && (itemX.code !== ""
      && (Utils.noUndfAndNull(itemX.dbattrId.code) && itemX.dbattrId.code !== "")
      && (Utils.noUndfAndNull(itemX.xmldefId.code) && itemX.xmldefId.code !== "")))
        return false;
    }
    //Uno de los objetos no está definido o es nulo mientras el otro sí está definido
    else if ((Utils.noUndfAndNull(itemX) && !Utils.noUndfAndNull(itemY)) || (!Utils.noUndfAndNull(itemX) && Utils.noUndfAndNull(itemY))) {
      return false;
    }
    return true;
  }

  /**
  * @description
  * Asigna a las propiedades del servicio sus valores por defecto
  */
  build() {
    this.dbmodels = new Dbmodels();
  }

}
